import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { UploadResponse } from '../models/import.model';
import { GlobalService } from '@core/services/global.service';

@Injectable({
  providedIn: 'root',
})
export class ImportService {
  private readonly globalService: GlobalService = inject(GlobalService);

  private readonly http: HttpClient = inject(HttpClient);
  apiUrl = environment.api.root;
  user = this.globalService.getCurrentUserData();
  constructor() {}

  uploadExcelFile(file: File): Observable<UploadResponse> {
    const formData = new FormData();
    formData.append('userId', this.user?.id?.toString() || '');
    formData.append('file', file);
    return this.http.post<UploadResponse>(
      `${this.apiUrl}/import/upload`,
      formData
    );
  }
}
